import { UpdateGroupDialog } from './../../dialogs/update.group/update.group.dialog';
import { UpdateVersionForceGroupItemArray } from './../../models/domain/update.version.force.group.item';
import { WindowService } from './../../services/window-dialogs/window.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../app/services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';

@Component({
    selector: 'update-group',
    templateUrl: './update.groups.component.html',
    styleUrls: ['./update.groups.component.scss']
})

export class UpdateGroupComponent implements OnInit {
    IsBusy: boolean = false;

    Groups: UpdateVersionForceGroupItemArray = new UpdateVersionForceGroupItemArray();

    GroupFilter: string;

    constructor(private dialogService: DialogService, private gb: GlobalService, private api: ssApiService, private windowService: WindowService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Updater Connections');
        // this.IsBusy = true;
        this.LoadGroups();
    }

    AddGroup() {
        let disposable = this.dialogService.addDialog(UpdateGroupDialog, {
            Title: 'Add Group'
        }, { width: 600, height: 650 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadGroups();
            }
        });

    }

    EditGroup(group) {
        let disposable = this.dialogService.addDialog(UpdateGroupDialog, {
            Title: 'Edit Group',
            Group: group
        }, { width: 600, height: 650 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.LoadGroups();
            }
        });
    }

    LoadGroups() {
        let disposable = this.api.GetUpdateVersionForceGroupsV3().subscribe(response => {
            this.Groups = response.Data;
            disposable.unsubscribe();
        });
    }

}
